import { createSelector } from "reselect";

export const selectLoad = (state) => state.load;

export const selectAllLoads = createSelector(
  selectLoad,
  (state) => state.all_loads
);

export const selectAllLoadsNo = createSelector(
  [selectLoad],
  (item) => item.all_loads_no
);

export const selectCurrentPage = createSelector(
  [selectLoad],
  (item) => item.current_page
);

export const selectLoadsListIsLoading = createSelector(
  [selectLoad],
  (item) => item.loadsList_isLoading
);

export const selectReqInfoIsLoading = createSelector(
  [selectLoad],
  (item) => item.reqInfo_isLoading
);

//
export const selectCurrentLoad = createSelector(
  [selectLoad],
  (item) => item.current_load
);

export const selectLoadBits = createSelector(
  [selectLoad],
  (item) => item.load_bits
);
